/**
 * After a tool step, the next model text-delta is often concatenated without a
 * blank line (`hinzu.Erledigt!`). Insert `\n\n` when needed for Markdown paragraphs.
 */
export function withParagraphBreakAfterTool(
  buffer: string,
  addition: string,
  needsBreak: boolean,
): string {
  if (!needsBreak || !addition) return addition;
  if (!buffer.trim()) return addition;
  if (/\n\n\s*$/.test(buffer) || /^\n/.test(addition)) return addition;
  return `\n\n${addition}`;
}
